import { getAllowedTabList } from 'src/services/client';
import { ModulePermission } from 'src/components/ContactForm/types';

export const requestModulePermissions = async (
  propertyId: string
): Promise<ModulePermission[]> => {
  const response: any = await getAllowedTabList(propertyId);

  if (!response.ok) {
    throw new Error(`Failed to fetch module permissions: ${response.status}`);
  }

  const result: any = await response.json();

  if (Array.isArray(result)) {
    return result;
  }

  return result?.data || [];
};